import React, { useEffect } from "react";
import Style from "./index.module.scss";
interface Props {
    src: string;
}
const Index = ({ src }: Props) => {
    useEffect(() => {
        window.open(src);
    }, []);
    return (
        <div className={Style.main}>
            <p>
                网页已在新窗口打开,{" "}
                <a href={src} target="_blank" rel="noreferrer">
                    [重新打开]
                </a>
            </p>
        </div>
    );
};

export default Index;
